import { REVIEWS_SECTION_LIST } from '../classnames/reviews';
import { Review } from './review';

export class ListRenderer {
  constructor() {
    this.container = document.getElementById(REVIEWS_SECTION_LIST);
  }

  render = (data) => {
    this.container.innerHTML = '';
    data.forEach(this.renderReview);
  };

  renderReview = (data) => {
    const review = new Review(data);

    review.render();

    this.container.appendChild(review.node);
  };
}
